
(function(){
  var routeMap={
    dashboard:"dashboard",products:"products",projects:"projects",roadmap:"roadmap",epics:"epics",releases:"releases",
    backlog:"backlog",planning:"planning",sprints:"sprints",board:"board",issues:"issues",bugs:"bugs",
    reviews:"reviews",qa:"qa",deploys:"deploys",team:"team",workload:"workload",time:"time",meetings:"meetings",
    docs:"docs",files:"files",analytics:"analytics"
  };
  function go(view){
    var target=routeMap[view]||view;
    var el=document.querySelector('[data-go="'+target+'"]');
    if(el){el.click();try{parent.postMessage({nir:1,type:"view",view:view},"*")}catch(e){}}
  }
  function brand(name){
    if(!name)return;
    var ws=document.querySelector(".ws div");
    if(ws){
      var n=ws.firstChild;
      if(n&&n.nodeType===3)n.nodeValue=name;
    }
    var logo=document.querySelector(".ws-logo");
    if(logo)logo.textContent=(name.trim()[0]||"H").toUpperCase();
    document.title="Ferro — Software delivery for "+name;
  }
  addEventListener("message",function(e){
    var d=e.data||{}; if(!d.nir)return;
    if(d.type==="goto")go(d.view);
    if(d.type==="brand")brand(d.name);
  });
})();
